import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import { Audios } from "@yamildiego/presentation-kit";

const PageId = 308;
const PreviousPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA_JOURNEY_ONE = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);
  const audioSrc = `${Config.BASE_URL}/audios/employee_onboarding/PRCX_18_Employee Onboarding - ${PageId}.mp3`;
  return {
    bgImage: `${Config.BASE_URL}/images/employee_onboarding/bg_5.png`,
    labels: [
      {
        icon: `${Config.BASE_URL}/images/icons/calendar.png`,
        text: "Day 26",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/location.png`,
        text: "Office",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/induction.png`,
        text: "Accreditation",
      },
    ],
    text: "Emma masters essential skills and\ncompliance requirements to finalise\nher accreditation in Probe CX.",
    rightSideImage: `${Config.BASE_URL}/images/employee_onboarding/win_08.png`,
    back: { label: "Go Back", type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { label: "Continue", type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={[{ src: audioSrc, timer: 0 }]} />,
  };
};

export default DATA_JOURNEY_ONE;
